import { FullPublicPhotoFragmentFragment } from "src/api/graphql/__generated__/graphql";
import lazy from "src/swsh-native/lazy";
import { ModalConfig } from "../types";

const PhotoPublicPreviewModal = lazy(
	() => import("src/screens/(internal)/(GatheringHome)/PhotoPublicPreviewModal"),
	{
		loading: () => null,
	},
);

type PublicGatheringModal = {
	PhotoPublicPreviewModal: {
		props: {
			gatheringId: string;
			photo: FullPublicPhotoFragmentFragment;
		};
	};
};

export default PublicGatheringModal;

export const PublicGatheringModalConfig = {
	PhotoPublicPreviewModal: {
		component: PhotoPublicPreviewModal,
		variant: "Blur",
	},
} satisfies ModalConfig<PublicGatheringModal>;
